import App from './App.vue';
import { auth0 } from './auth0';
import { router } from './router';
import './style.scss';
import vueformConfig from './vueform.config';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUpRightFromSquare,
  faCartShopping,
  faGear,
  faPenToSquare,
  faToolbox,
  faTrashCan,
  faUserPen,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// Vuetify
import '@mdi/font/css/materialdesignicons.css';
import * as Sentry from '@sentry/vue';
import Vueform from '@vueform/vueform';
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';

// Add used icons
library.add(faTrashCan, faPenToSquare, faCartShopping, faToolbox, faArrowUpRightFromSquare, faGear, faUserPen);

const pinia = createPinia();

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://e29249ca8074b0e8b5940c4cf2aff001@o4508093485088768.ingest.de.sentry.io/4509031683850320',
});

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.use(auth0);
app.use(pinia);
app.use(vuetify);
app.use(Vueform, vueformConfig);
app.use(router);
app.mount('#app');
